/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation MncDeleteMutation($mncId: ID!) {
  MncDelete(mncId: $mncId) {
    id
    message
    status
  }
}
`
